import {neverland as $, render, html, useState} from 'neverland';

import Menu from './Menu.js';
import LoginPage from './LoginPage.js';
import ForgotPasswordPage from './ForgotPasswordPage.js';
import ConfirmPasswordPage from './ConfirmPasswordPage.js';
import ConfirmForgotPasswordPage from './ConfirmForgotPasswordPage.js';
import ResetPasswordPage from './ResetPasswordPage.js';
import ResetSuccessPage from './ResetSuccessPage.js';
import MFASetupPage from './MFASetupPage.js';
import MFAVerifyPage from './MFAVerifyPage.js';

import Collection from './Collection.js';
import CSVCreator from './CSVCreator.js';
import collections from '../specs/collections.js';

const Router = $(function({auth, setAuth}) {
	
	if (auth.publicPage === null) {

		switch (auth.isLoggedIn) {
			case true:
				return html`
					${Menu({auth, setAuth})}
					${auth.page === 'ClientGroups' && auth.isAdmin ? Collection(auth, collections.ClientGroups) : ''}
					${auth.page === 'Items' ? Collection(auth, collections.Items) : ''}
					${auth.page === 'ItemSets' ? Collection(auth, collections.ItemSets) : ''}
					${auth.page === 'Surveys' && (auth.isAdmin) ? Collection(auth, collections.Surveys) : ''}
					${auth.page === 'Responses' && (auth.isAdmin) ? Collection(auth, collections.Responses) : ''}
					${auth.page === 'CSVCreator' && (auth.isAdmin || auth.isResearcher) ? CSVCreator(auth) : ''}
					${auth.page === 'CSVDownloads' && auth.isAdmin ? Collection(auth, collections.CSVDownloads) : ''}
					${auth.page === 'Themes' && auth.isAdmin ? Collection(auth, collections.Themes) : ''}
					${auth.page === 'EndScreens' && auth.isAdmin ? Collection(auth, collections.EndScreens) : ''}
				`;
				break;
			default:
				return html`
					${LoginPage({auth, setAuth})}
				`;
				break;
		}


	} else {

		switch (auth.publicPage) {
			case 'ForgotPassword':
				return html`
					${ForgotPasswordPage({auth, setAuth})}
				`;
				break;
			case 'ConfirmPassword':
				return html`
					${ConfirmPasswordPage({auth, setAuth})}
				`;
				break;
			case 'ConfirmForgotPassword':
				return html`
					${ConfirmForgotPasswordPage({auth, setAuth})}
				`;
				break;
			case 'ResetPassword':
				return html`
					${ResetPasswordPage({auth, setAuth})}
				`;
				break;
			case 'ResetSuccess':
				return html`
					${ResetSuccessPage({setAuth})}
				`;
				break;
		case 'MFASetup':
				return html`
					${MFASetupPage({auth, setAuth})}
				`;
				break;
		case 'MFAVerify':
				return html`
					${MFAVerifyPage({auth, setAuth})}
				`;
				break;
		}

	}



});

export default Router;

// THOUGHTS

// - Use MongoDB users for admin app.
// - Use Custom Function authentication for reporting portal users.